import React from 'react';
import { CheckCircle2, Package, Download, FileText } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const OliveSqualeneDetail = ({ product }) => {
  if (!product.qualitySpecs && !product.packaging) return null;

  return (
    <div className="mt-8 space-y-10">
      {/* Quality Standards */}
      {product.qualitySpecs && (
        <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-300">
          <CardContent className="p-8">
            <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" />
              {product.qualitySpecs.title}
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              {product.qualitySpecs.description}
            </p>
          </CardContent>
        </Card>
      )}

      {/* Bulk Packaging */}
      {product.packaging && product.packaging.bulk && (
        <div>
          <h4 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <Package className="w-6 h-6 mr-2 text-blue-600" />
            Bulk Loading Options
          </h4>
          <div className="grid md:grid-cols-2 gap-6">
            {product.packaging.bulk.map((pack) => (
              <Card key={pack.type} className="border-2 hover:shadow-xl transition-all hover:border-blue-400">
                <CardContent className="p-6">
                  <h5 className="text-xl font-bold text-gray-900 mb-3">{pack.type}</h5>
                  <p className="text-gray-700 mb-2">{pack.description}</p>
                  <p className="text-sm font-semibold text-blue-600">
                    Capacity: {pack.capacity}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* PDF Specification Download */}
      {product.pdfSpec && (
        <Card className="bg-gradient-to-br from-indigo-50 to-purple-50 border-2 border-indigo-300 shadow-xl">
          <CardContent className="p-8">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="flex-shrink-0">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-indigo-100 rounded-full">
                  <FileText className="w-10 h-10 text-indigo-600" />
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {product.pdfSpec.title}
                </h3>
                <p className="text-gray-700 mb-4">
                  {product.pdfSpec.description}
                </p>
                <a
                  href={product.pdfSpec.file}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-all duration-300 hover:shadow-lg"
                >
                  <Download className="w-5 h-5 mr-2" />
                  Download Technical Specifications (PDF)
                </a>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default OliveSqualeneDetail;
